// extracted by mini-css-extract-plugin
export var chip = "_mr-0";
export var icon = "_mr-1";
export var remove = "_mr-2";
export var removeIcon = "_mr-3";